
/*
 * Extended bootstrap tab.
 * Extra features:
 *  * `data-target` or `href` are optional, default behaviour is to find corresponding tab by index
 */

const { document } = require('window');

const $ = require('jquery');
require('bootstrap');

const cuid = require('cuid');


// eslint-disable-next-line no-unused-vars
const Plugin = $.fn.tab;
const Tab = $.fn.tab.Constructor;

function ExtendedTab () {
	Tab.apply(this, arguments);
	this.constructor = ExtendedTab;
	return this;
}

ExtendedTab.prototype = $.extend(Object.create(Tab.prototype), {
	targetFallback: function () {
		const $this = this.element;

		const target = $this.data('target');
		const href = $this.attr('href');
		if (target || (href && href !== '#')) {
			// target set explicitly, nothing to do
			return;
		}

		const $li = $this.closest('li');
		const $ul = $this.closest('ul:not(.dropdown-menu)');

		const i = $('> li', $ul).index($li);

		const $tabContent = $ul.next('.tab-content');
		if (!$tabContent.length) {
			return;
		}
		const $panes = $('> .tab-pane', $tabContent);

		const $target = $($panes.get(i));
		if (!$target.length) {
			return;
		}

		let id;
		if ($target.attr('id')) {
			id = $target.attr('id');
		} else {
			id = cuid();
			$target.attr('id', id);
		}
		$this.attr('data-target', '#' + id);
	},
	show: function () {
		this.targetFallback();
		return Tab.prototype.show.apply(this, arguments);
	},
});


function ExtendedPlugin (option) {
	return this.each(function () {
		const $this = $(this);
		let data = $this.data('bs.tab');

		if (!data) {
			$this.data('bs.tab', (data = new ExtendedTab(this)));
		}
		if (typeof option == 'string') {
			data[option]();
		}
	});
}

$.fn.tab = ExtendedPlugin;
$.fn.tab.Constructor = Tab;

module.exports = $.fn.tab;

const clickHandler = function (e) {
	e.preventDefault();
	ExtendedPlugin.call($(this), 'show');
};

$(document)
	.off('click.bs.tab.data-api', '[data-toggle="tab"]')
	.off('click.bs.tab.data-api', '[data-toggle="pill"]')
	.on('click.bs.tab.data-api', '[data-toggle="tab"]', clickHandler)
	.on('click.bs.tab.data-api', '[data-toggle="pill"]', clickHandler);

